// class CartNotification extends HTMLElement {
//   constructor() {
//     super();

//     this.notification = document.getElementById('cart-notification');
//     this.header = document.querySelector('sticky-header');
//     this.onBodyClick = this.handleBodyClick.bind(this);

//     this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
//       closeButton.addEventListener('click', this.close.bind(this))
//     );
//   }

//   open() {
//     this.notification.classList.add('animate', 'active');

//     this.notification.addEventListener(
//       'transitionend',
//       () => {
//         this.notification.focus();
//         trapFocus(this.notification);
//       },
//       { once: true }
//     );

//     document.body.addEventListener('click', this.onBodyClick);
//   }

//   close() {
//     this.notification.classList.remove('active');
//     document.body.removeEventListener('click', this.onBodyClick);

//     removeTrapFocus(this.activeElement);
//   }

//   renderContents(parsedState) {
//     this.cartItemKey = parsedState.key;
//     this.getSectionsToRender().forEach((section) => {
//       document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     if (this.header) this.header.reveal();
//     this.open();
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-notification-product',
//         selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
//       },
//       {
//         id: 'cart-notification-button',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   handleBodyClick(evt) {
//     const target = evt.target;
//     if (target !== this.notification && !target.closest('cart-notification')) {
//       const disclosure = target.closest('details-disclosure, header-menu');
//       this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
//       this.close();
//     }
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-notification', CartNotification);
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  // renderContents(parsedState) {
  //   this.cartItemKey = parsedState.key;

  //   // Update notification product info
  //   this.getSectionsToRender().forEach((section) => {
  //     const el = document.getElementById(section.id);
  //     if (!el) return;

  //     if (section.id === 'cart-notification-product') {
  //       // Build product HTML manually from the response
  //       const item = parsedState;
  //       el.innerHTML = this.buildProductHTML(item);
  //     } else if (section.id === 'cart-notification-button') {
  //       // Update the "View cart" button text with item count
  //       el.textContent = el.textContent;
  //     } else if (section.id === 'cart-icon-bubble') {
  //       // Update cart count bubble
  //       this.updateCartCount();
  //     }
  //   });

  //   if (this.header) this.header.reveal();
  //   this.open();
  // }
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Update notification product info
    const productEl = document.getElementById('cart-notification-product');
    if (productEl) {
      productEl.innerHTML = this.buildProductHTML(parsedState);
    }

    // Always update cart count in header
    this.updateCartCount();

    if (this.header) this.header.reveal();
    this.open();
  }

  buildProductHTML(item) {
    const imgSrc = item.image ? item.image : '';
    const imgTag = imgSrc
      ? `<img src="${imgSrc}" alt="${item.product_title}" width="70" height="70" loading="lazy" style="object-fit: cover; border-radius: 4px;">`
      : '';

    let variantInfo = '';
    if (item.variant_title) {
      variantInfo = `<p class="product-option" style="margin: 2px 0; font-size: 13px; color: #666;">${item.variant_title}</p>`;
    }

    return `
      <div id="cart-notification-product-${item.key}" style="display: flex; align-items: center; gap: 15px; padding: 15px;">
        <div style="width: 70px; height: 70px; flex-shrink: 0;">
          ${imgTag}
        </div>
        <div>
          <h3 class="cart-notification-product__name" style="margin: 0; font-size: 14px; font-weight: 600;">${item.product_title}</h3>
          ${variantInfo}
          <p style="margin: 4px 0 0; font-size: 13px;">${item.quantity} × ${this.formatMoney(item.final_line_price)}</p>
        </div>
      </div>
    `;
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    // Detect currency from Shopify
    const symbol = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? this.getCurrencySymbol(window.Shopify.currency.active)
      : '£';
    return symbol + amount;
  }

  getCurrencySymbol(currencyCode) {
    const symbols = { GBP: '£', USD: '$', EUR: '€', CAD: 'CA$', AUD: 'A$' };
    return symbols[currencyCode] || currencyCode + ' ';
  }

updateCartCount() {
    fetch(window.routes.cart_url + '.js')
      .then((r) => r.json())
      .then((cart) => {
        // Target all cart bubble elements (custom navbar + any default Dawn ones)
        const bubbles = document.querySelectorAll('[class*="cart-bubble"], .cart-count-bubble, #cart-icon-bubble .cart-count-bubble');
        
        bubbles.forEach((bubble) => {
          bubble.textContent = cart.item_count;
        });

        // Also update any default Dawn cart icon bubble
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          const countEl = cartIconBubble.querySelector('[aria-hidden="true"]');
          if (countEl) countEl.textContent = cart.item_count;
        }
      })
      .catch((err) => console.error('Cart count update failed:', err));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);